<div
  class="input-wrapper"
  [formGroup]="formGroup"
  [class.disabled]="disabled"
  [class.input-error]="f[controlName].invalid && f[controlName].touched"
>
  <span class="p-float-label p-input-icon-right">
    <input
      class="taly-input"
      dir="ltr"
      [formControlName]="controlName"
      pInputText
      [id]="id"
      [placeholder]="placeholderText"
      type="text"
      [attr.inputmode]="inputmodeType"
      [value]="value"
      #inputField
      [disabled]="disabled"
      [maxlength]="max"
    />
    <label [htmlFor]="id" translate class="w-100">{{ label }}</label>
    @if (!disabled) {
      @if (inputField.value) {
        <i
          class="pi pi-times"
          (click)="onReset()"
          (keyup.enter)="onReset()"
          tabindex="0"
          role="button"
          aria-label="Reset input"
        ></i>
      }
    }
  </span>
</div>
@if (f[controlName].invalid && f[controlName].touched) {
  <div class="alert">
    @if (f[controlName].hasError('required')) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        {{ label | translate }} <span class="alert-danger" translate>COMMON.REQUIRED</span>
      </span>
    }
    @if (!f[controlName].hasError('required') && f[controlName]?.hasError('minlength')) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate [translateParams]="{ min: min }"
          >COMMON.MIN_LENGTH</span
        >
        {{ label | translate }}
      </span>
    }
    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      f[controlName]?.hasError('maxlength')
    ) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate [translateParams]="{ max: max }"
          >COMMON.MAX_LENGTH</span
        >
        {{ label | translate }}
      </span>
    }
    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      !f[controlName]?.hasError('maxlength') &&
      f[controlName]?.hasError('email')
    ) {
      <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
      <span class="alert-danger" translate> COMMON.INVALID_EMAIL </span>
    }
    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      !f[controlName]?.hasError('maxlength') &&
      !f[controlName]?.hasError('email') &&
      f[controlName]?.hasError('pattern')
    ) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate>COMMON.VALID_ENTER</span> {{ label | translate }}
      </span>
    }
  </div>
}
